var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-system-bar',{attrs:{"color":"darkgrey","dark":""}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("mdi-account")]),_c('span',{staticClass:"user-name primary--text"},[_vm._v(" "+_vm._s(_vm.userName)+" "),(_vm.planName)?_c('span',[_vm._v(" - "+_vm._s(_vm.planName))]):_vm._e(),(_vm.isDivided)?_c('span',[_vm._v(" - Parcelado")]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }